import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import Logger from '../functions/logging';
import '../static/mpaa.css';
import EllationBranding from '../assets/viewer-consent/ellation-consent-logo.png';
import PilotlyBranding from '../assets/landing/pilotly-logo-white.png';
import SocialShare from '../assets/viewer-consent/laymen-social-share.png';
import VideoShare from '../assets/viewer-consent/laymen-video-share.png';

import FadeIn from '../components/global/FadeIn';
import Feedback from '../components/global/Feedback';
import PageLoader from '../components/global/PageLoader';

import * as auth from '../functions/auth';
import * as TargetProcess from '../functions/targetProcess';
import { checkUserAcceptedDisclaimers } from '../functions/helpers';
import { getLanguageWithoutRegionCode, getLocale } from '../functions/locale';

import register from '../api/register';
import login from '../api/login';
import { getUser, updateUserDisclaimer } from '../api/user';
import { groupJoinSubscription, groupSubscribe, getNDAPrompt } from '../api/group';
import { setTargetParams, setCurrentUser, setUserDisclaimer } from '../redux/actions/index';

import localeMessages from '../locales/register';

import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';
import { VIEWER_NDA_CONSENT } from '../constants/registrationConstants';
import { CONSENT_FORM_TERMINATION } from '../constants/screenCodes';
import { enableFullscreen } from '../functions/fullscreen';
import DeviceHelper from '../functions/device';
import MobileLaymensTerms from './MobileLaymensTerms';

const SUB_PARAMS = ['list', 'group'];
const CONSTENT_PROMPTS = ['amazon', 'amazon-it', 'amazon-eu-es', 'amazon-es', 'amazon-mx', 'amazon-de', 'amazon-br', 'amazon-ja', 'ellation', 'ellation-mx', 'ellation-br', 'netflix-us', 'nda-prompt', 'pilotly-nda'];

class ViewerConsentDisclaimer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			consentPromptDisplay: true,
			videoResponseAcceptanceDisplay: false,
			userStudyStatus: null,
			userAcceptedDisclaimer: false,
			intiUserDisclaimer: false,
			ready: false,
			enableSigning: false
		};

		this.trackScrolling = this.trackScrolling.bind(this);
		this.checkUserCompletionStatus = this.checkUserCompletionStatus.bind(this);
		this.declineConsentDisclaimer = this.declineConsentDisclaimer.bind(this);
		this.acceptConsentDisclaimer = this.acceptConsentDisclaimer.bind(this);
		this.continueStudy = this.continueStudy.bind(this);

		this.renderViewerConsentForm = this.renderViewerConsentForm.bind(this);
		this.renderLaymensTerms = this.renderLaymensTerms.bind(this);
	}

	componentDidMount() {
		// get the user object if user_token exists
		let user_token = auth.getToken();
		let screenerPrompt = this.returnScreenerPrompt(this.props.fetchedGroup, this.props.targetParams);

		if (user_token && (!this.props.targetParams || (!this.props.targetParams.partner && !this.props.targetParams.dl))) {
			this.loadUser(user_token);
		}

		if (user_token
			&& this.props.fetchedGroup
			&& this.props.fetchedGroup._id
			&& screenerPrompt === 'nda-prompt'
		) {
			let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ?
				this.props.targetParams.ps.toString()
				:
				null;
			this.loadScreenerPrompt(this.props.fetchedGroup, panelSegmentIndex, user_token);
		}

		if (user_token
			&& this.props.targetParams
			&& (this.props.targetParams.partner || this.props.targetParams.dl)
		) {
			auth.logout(() => { this.props.setCurrentUser(null); });
		}
		if (this.props.targetParams && this.props.targetParams.fakeUser) {
			this.createUserAuth(this.props.targetParams.fakeUser.email, this.props.targetParams.fakeUser.password);
		}
		else {
			// eslint-disable-next-line react/no-did-mount-set-state
			this.setState({ ready: true });
		}

		if (this.props.currentUser && this.props.targetParams && this.props.targetParams.gid && !this.state.userStudyStatus) {
			this.checkUserCompletionStatus(this.props.currentUser, this.props.targetParams.gid);
		}

		// document.addEventListener('scroll', this.trackScrolling);
	}

	componentDidUpdate() {
		if (this.props.currentUser && this.props.targetParams && this.props.targetParams.gid && !this.state.userStudyStatus) {
			this.checkUserCompletionStatus(this.props.currentUser, this.props.targetParams.gid);
		}

		if (this.props.currentUser
			&& this.props.targetParams
			&& this.props.targetParams.gid
			&& !this.state.intiUserDisclaimer
			&& checkUserAcceptedDisclaimers(this.props.currentUser, this.props.targetParams.gid, VIEWER_NDA_CONSENT)
		) {
			this.setState({ userAcceptedDisclaimer: true });
		}

		if (this.state.userAcceptedDisclaimer) {
			// this.continueStudy();
		}

		let consentForm = document.getElementById('NDAConsentForm');
		if (consentForm
			&& consentForm.scrollHeight <= consentForm.offsetHeight
			&& !this.state.enableSigning
		) {
			this.setState({ enableSigning: true });
		}
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.trackScrolling);
	}

	async createUserAuth(userEmail, userPassword) {
		try {
			const result = await login(userEmail, userPassword);
			if (result) {
				Logger.log(this.constructor.name, "createUserAuth() User Login Success", result);
				if (!this.props.targetParams || !this.props.targetParams.fakeUser) auth.setLogin(userEmail);
				if (this.props.targetParams && this.props.targetParams.fakeUser) auth.deletePortalEmail();
				auth.setToken(result);
				this.loadUser(result);
			}
			else {
				Logger.log(this.constructor.name, "createUserAuth() User Login Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
				this.setState({ errors: errors, ready: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "createUserAuth() User Login Failed", error);
			errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
			this.setState({ errors: errors, ready: true });
		}
	}

	async loadUser(user_token, callback) {
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() User Success", result);
				this.props.setCurrentUser(result);
				this.setState({ ready: true });
				if (callback) setTimeout(() => { callback(); }, 500);
			}
			else {
				Logger.log(this.constructor.name, "loadUser() User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors: errors, ready: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors: errors, ready: true });
		}
	}

	async loadScreenerPrompt(group, ps, user_token) {
		try {
			const result = await getNDAPrompt(group._id, ps, user_token);

			if (result) {
				Logger.log(this.constructor.name, "loadScreenerPrompt() NDA Success", result);
				this.setState({ ready: true, ndaPrompt: result });
			}
			else {
				Logger.log(this.constructor.name, "loadScreenerPrompt() NDA Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors: errors, ready: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadScreenerPrompt() NDA Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors: errors, ready: true });
		}
	}

	async setTerminatedUserSubscription(screen_code) {
		let user_token = auth.getToken();
		let user_id = this.props.currentUser.user_id;
		let video_id = this.props.fetchedGroup.video_id;
		let group_id = this.props.fetchedGroup._id;
		let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ?
			this.props.targetParams.ps.toString()
			:
			null;

		let subscribeFn = this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) ? groupJoinSubscription : groupSubscribe;
		const isTester = TargetProcess.isTester(this.props.targetParams);
		const userLanguageCode = getLocale() || (this.props.targetParams && this.props.targetParams.lang) || getLanguageWithoutRegionCode();

		Logger.log(this.constructor.name, "setTerminatedUserSubscription() suscribe, tester", (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl)), isTester, this.props.targetParams);
		try {
			const result = await subscribeFn(user_token, user_id, video_id, group_id, panelSegmentIndex, userLanguageCode, 1, screen_code, isTester, true);

			if (result) {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group: ", result);
				this.loadUser(user_token, () => { this.updateUserConsentDisclaimer(this.props.currentUser, 'decline-viewer-consent', () => { this.setState({ userStudyStatus: 'ineligible' }); }); });

			}
			else {
				Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "setTerminatedUserSubscription() Group Subscription Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_terminating_user);
			this.setState({ errors: errors });
		}
	}

	async updateUserConsentDisclaimer(user, consentDisclaimerAction, callback) {
		let user_token = auth.getToken();
		let user_id = this.props.currentUser.user_id;
		let group_id = this.props.fetchedGroup._id;
		let panelSegmentIndex = this.props.targetParams.ps || this.props.targetParams.ps === 0 ? this.props.targetParams.ps.toString() : null;
		let userGroupMetadata = this.getUserGroupMetadata(this.props.currentUser, group_id);
		let disclaimers = userGroupMetadata && userGroupMetadata.disclaimers && userGroupMetadata.disclaimers.length ? userGroupMetadata.disclaimers : {};

		Logger.log(this.constructor.name, "updateUserConsentDisclaimer() VIEWER CONSENT: ", consentDisclaimerAction, disclaimers);
		switch (consentDisclaimerAction) {
			case 'accept-viewer-consent': {
				disclaimers[VIEWER_NDA_CONSENT] = true;
				break;
			}
			case 'decline-viewer-consent': {
				disclaimers[VIEWER_NDA_CONSENT] = false;
				break;
			}
		}

		let method = userGroupMetadata ? "update" : "create";
		try {
			let result = await updateUserDisclaimer(user_id, user_token, panelSegmentIndex, group_id, disclaimers, userGroupMetadata, method);
			if (result) {
				Logger.log(this.constructor.name, "acceptConsentDisclaimer() Result: ", result);
				if (consentDisclaimerAction === 'accept-viewer-consent') this.setState({ userAcceptedDisclaimer: true });
				if (callback) callback();
			}
			else {
				Logger.log(this.constructor.name, "acceptConsentDisclaimer() Video Disclaimer Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_updating_video_disclaimer);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "acceptConsentDisclaimer() Video Disclaimer Failed: No result", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_updating_video_disclaimer);
			this.setState({ errors: errors });
		}
	}

	trackScrolling() {
		Logger.log(this.constructor.name, "trackScrolling() TRACK SCROLLING");
		let wrappedElement = document.getElementById('ConsentForm');
		let dbNDAElement = document.getElementById('NDAConsentForm');
		let signingElement = document.getElementById('SigningInstructions');
		let isElementAtBottom = (wrappedElement, signingElement) => {
			return wrappedElement.getBoundingClientRect().bottom >= signingElement.getBoundingClientRect().bottom;
		};

		if ((wrappedElement && signingElement && isElementAtBottom(wrappedElement, signingElement)) ||
			((dbNDAElement.scrollTop - (dbNDAElement.scrollHeight - dbNDAElement.offsetHeight) >= 0)
				&& (dbNDAElement.scrollTop - (dbNDAElement.scrollHeight - dbNDAElement.offsetHeight) <= 5)) // get within 5px of the bottom
		) {
			Logger.log(this.constructor.name, "trackScrolling() ENABLE SUBMISSION");
			this.setState({ enableSigning: true });
		}
	}

	getUserGroupMetadata(authedUser, group_id) {
		if (authedUser && authedUser.viewer_metadata && authedUser.viewer_metadata.length && group_id) {
			for (let i = 0; i < authedUser.viewer_metadata.length; i++) {
				let metadata = authedUser.viewer_metadata[i];
				if (metadata.group_id === group_id) {
					return metadata;
				}
			}
		}
		return null;
	}

	checkUserCompletionStatus(authedUser, group_id) {
		const { targetParams, globalAnalyticsAdapter } = this.props;
		const isPartner = targetParams && targetParams.partner;
		const isDistList = targetParams && targetParams.dl;
		if (authedUser.subscriptions && authedUser.subscriptions.list && authedUser.subscriptions.group && (authedUser.subscriptions.list.length || authedUser.subscriptions.group.length)) {

			for (let spIndex = 0; spIndex < SUB_PARAMS.length; spIndex++) {
				let subParam = SUB_PARAMS[spIndex];

				for (let i = 0; i < authedUser.subscriptions[subParam].length; i++) {
					let groupSubscription = authedUser.subscriptions[subParam][i];
					if (groupSubscription.group_id === group_id && groupSubscription.complete) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'CompletedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						this.setState({ userStudyStatus: "alreadycompleted" });
						return;

					}
					else if (groupSubscription.group_id === group_id && groupSubscription.screened) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'ScreenedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						this.setState({ userStudyStatus: "ineligible" });
						return;
					}
				}
			}
		}
	}

	declineConsentDisclaimer(screen_code) {
		this.setState({ ready: false });

		if (this.props.currentUser) {
			this.setTerminatedUserSubscription(screen_code);
		}
	}

	acceptConsentDisclaimer() {
		this.setState({ ready: false, consentPromptDisplay: false, laymensPromptDisplay: true });

		if (this.props.currentUser) {
			this.updateUserConsentDisclaimer(this.props.currentUser, 'accept-viewer-consent');
		}
	}

	async continueStudy(route) {
		if (route) {
			this.props.history.push(route);
		}

		const targetParams = this.props.targetParams;
		const userAcceptedDisclaimer = this.state.userAcceptedDisclaimer;
		if (userAcceptedDisclaimer) {
			if (targetParams && targetParams.gid) {
				if (targetParams.mpaa) {
					this.props.history.push("/mpaa");
				}
				else if (this.props.currentUser) {
					//The Web API requestFullscreen() just works when executed by a user interaction. Click or touch.
					await enableFullscreen();
					this.props.history.push("/study");
				}
				else {
					this.props.history.push("/register");
				}
			}
			else {
				this.props.history.push("/register");
			}
		}
	}

	returnScreenerPrompt(group, targetParams) {
		let psIndex = targetParams.panelSegmentIndex || targetParams.ps || '0';
		let screenerPrompt = 'ellation';
		if (group &&
			group.panel_segment &&
			group.panel_segment[psIndex] &&
			group.panel_segment[psIndex].screener_prompts &&
			group.panel_segment[psIndex].screener_prompts.length
		) {
			CONSTENT_PROMPTS.forEach((prompt) => {
				if (group.panel_segment[psIndex].screener_prompts.includes(prompt)) {
					screenerPrompt = prompt;
				}
			});
		}
		return screenerPrompt;
	}

	returnScreenerBranding(screenerPrompt) {
		switch (screenerPrompt) {
			case "ellation": {
				return EllationBranding;
			}
			default: {
				return PilotlyBranding;
			}
		}
	}

	renderViewerConsentForm(formType) {
		let consentForm = '';
		let declineText = "";
		let acceptText = "";
		let enableSigning = this.state.enableSigning;
		let ndaPrompt = this.state.ndaPrompt;

		let consentClassName = 'consent-instruction-form';
		if (DeviceHelper.isMobile) {
			consentClassName = 'consent-instruction-form-mobile';
		}

		switch (formType) {
			case 'nda-prompt': {
				if (ndaPrompt) {
					consentForm = (
						<div className="pilotly-register-form nda-prompt video-consent p-0">
							<div className="register-form-message mb-10"
								dangerouslySetInnerHTML={{ __html: ndaPrompt.header }}>
							</div>

							<div id="NDAConsentForm"
								onScroll={this.trackScrolling}
								className={"mb-20 overflow-auto text-align-left " + consentClassName}
								dangerouslySetInnerHTML={{ __html: ndaPrompt.body }}>
							</div>
						</div>
					);
					declineText = ndaPrompt.decline_text;
					acceptText = ndaPrompt.accept_text;
				}
				break;
			}
			case "ellation": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Security Consent Non-Disclosure Agreement</h4>
							<p>Please read the the following and be sure to scroll to the end to complete reading</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>
							<p className="mb-20">
								Thank you for participating in Ellation's usability research, whether online or in person, individually or as part of a focus group. We will be recording your session to allow for future reference and to share with the rest of the organization or for other uses. As a participant in our usability research, you agree to the following:
							</p>

							<ol>
								<li className="mb-15">
									To participate in the study conducted and recorded by Ellation, Inc. ("Ellation").
								</li>
								<li className="mb-15">
									That you understand and consent to the use and release of the audio and video recording by Ellation. You agree to relinquish any rights to the recording and understand the recording may be copied and used by Ellation, its employees, agents, contractors, affiliates and assigns without further permission or payment of any kind. You specifically and irrevocably hereby grant to Ellation the right to use and otherwise exploit the recordings, and every element thereof, in any and all media, now known or hereafter devised, in perpetuity, throughout the universe, and for any purpose, including, without limitation, on website(s), mobile platforms and widgets owned, controlled and/or administered by Ellation and/or any of its licensees and/or any of its affiliates, and in any advertising related to promotion and marketing.
								</li>

								<li className="mb-15">
									That you understand that your participation in this usability study is voluntary and you agree to immediately raise any concerns or areas of discomfort during the session with the study administrator.
								</li>

								<li className="mb-15">
									That you will use Confidential Information of Ellation only for the purpose of participating in this usability research and you will not disclose Ellation's Confidential Information to any third party. "Confidential Information" means any non-public information that relates to the actual or anticipated business and/or products, research or development of Ellation, its affiliates or subsidiaries, or to Ellation's, its affiliates' parent's or subsidiaries' technical data, intellectual property, trade secrets, or know-how, including, but not limited to, research, product plans, or other information regarding Ellation's, its affiliates' parent's or subsidiaries' current or future products or services and markets therefore, customer lists and customers, software, developments, inventions, processes, formulas, technology, designs, drawings, engineering, hardware configuration information, marketing, finances, and other business information disclosed by Ellation either directly or indirectly, in writing, orally or by drawings or inspection of premises, parts, equipment, or other property of Ellation. Notwithstanding the foregoing, Confidential Information shall not include any such information which you can establish (i) was publicly known or made generally available prior to the time of disclosure to Contractor, or (ii) becomes publicly known or made generally available after disclosure to Contractor through no wrongful action or inaction of Contractor.
								</li>
							</ol>

							<p id="SigningInstructions"
								className="font-bold">
								By signing below, you acknowledge and agree that you have read this release prior to signing, that you understand and agree to the terms set forth herein and that you have freely entered into this agreement.
							</p>
						</div>
					</div>
				);
				declineText = "Decline";
				acceptText = "Digitally Sign";
				break;
			}
			case "ellation-mx": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Acuerdo de Confidencialidad y Consentimiento de Seguridad</h4>
							<p>Por favor, lea los siguientes términos y asegúrese de completar la lectura del documento</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>
							<p className="mb-20">
								Gracias por participar en esta prueba de usabilidad de Ellation, ya sea online o en persona, individualmente o como parte de un grupo focal. Grabaremos su sesión para poder usarla como referencia en el futuro y compartirla con el resto de organización o darle otros usos. Como participante en nuestra prueba de usabilidad, accede a lo siguiente:
							</p>

							<ol>
								<li className="mb-15">
									Que usted participará en un estudio conducido y grabado por Ellation, Inc. (Ellation).
								</li>
								<li className="mb-15">
									Que acepta y da su consentimiento para el uso y divulgación de la grabación audiovisual realizada por Ellation. Acepta renunciar a cualquier derecho sobre la grabación y comprende que esta podrá ser copiada y utilizada por Ellation, sus empleados, agentes, contratistas, afiliados y cesionarios sin necesidad de ningún permiso ni pago adicional. Por el presente, usted otorga de manera específica e irrevocable a Ellation el derecho para usar y explotar las grabaciones y cualquier elemento de las mismas, en todos y cada uno de los medios, ahora conocidos o desarrollados en el futuro, a perpetuidad, en todo el universo y para cualquier propósito, incluyendo, sin limitaciones, en sitios web, plataformas móviles y aplicaciones de propiedad, controladas o gestionadas por Ellation y/o cualquiera de sus licenciatarios y/o afiliados, y en cualquier material publicitario relacionado con la promoción y el marketing.
								</li>

								<li className="mb-15">
									Que comprende que su participación en este estudio de usabilidad es voluntaria y que avisará de forma inmediata al administrador del estudio de cualquier inquietud o motivo de incomodidad que sienta durante la sesión.
								</li>

								<li className="mb-15">
									{`Que utilizará Información Confidencial de Ellation solo con el fin de participar en este estudio de usabilidad y que no divulgará Información Confidencial de Ellation a ningún tercero. En este contexto, "Información Confidencial" se considera cualquier información no pública relacionada con cualquier negocio, producto, estudio o desarrollo de Ellation, sus filiales o subsidiarias, datos técnicos, propiedad intelectual, secretos comerciales o know-how, actuales o futuros, de Ellation, sus filiales o subsidiarias, incluyendo, pero no limitándose a, estudios, productos o servicios actuales o futuros, listas de clientes y clientes, software, desarrollos, inventos, procesos, fórmulas, tecnología, diseños, dibujos, ingeniería, información de la configuración del hardware, marketing, finanzas y cualquier otra información comercial divulgada por Ellation de forma directa o indirecta, ya sea por escrito, oralmente o mediante dibujos o inspección de piezas, equipo o premisas de cualquier propiedad de Ellation. Sin perjuicio de lo anterior, la Información Confidencial no incluirá en ningún caso ningún tipo de información que pueda establecerse que (i) fue divulgada públicamente o era de conocimiento público antes de que fuera divulgada al Contratista, o (ii) que se divulgó públicamente o se puso a disposición general tras ser divulgada al Contratista sin mediación alguna por parte del Contratista.`}
								</li>
							</ol>

							<p id="SigningInstructions"
								className="font-bold">
								Al firmar debajo, usted reconoce haber leído este documento antes de firmar, comprender y estar de acuerdo con los términos establecidos, habiendo accedido a firmar de forma voluntaria.
							</p>
						</div>
					</div>
				);
				declineText = "Rechazar";
				acceptText = "Firmar digitalmente";
				break;
			}
			case "ellation-br": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Acordo de Confidencialidade e Consentimento de Segurança</h4>
							<p>Por favor, leia os termos a seguir e atinja o fim do documento para finalizar a leitura</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>
							<p className="mb-20">
								Obrigado por participar do teste de usabilidade da Ellation, online ou em pessoa, individualmente ou como parte de um grupo focal. Nós gravaremos a sua sessão para permitir estudos posteriores e para compartilhar internamente na organização com outros fins. Como participante da pesquisa de usabilidade, você concorda com os seguintes termos:
							</p>

							<ol>
								<li className="mb-15">
									Que você participará de um estudo conduzido e gravado pela Ellation, Inc. (Ellation)
								</li>
								<li className="mb-15">
									Que você está de acordo com o uso e divulgação da gravação audiovisual produzida pela Ellation. Você concorda em abrir mão de todos os direitos referentes à gravação, e concorda em fornecer a gravação para cópia e uso da Ellation, seus empregados, agentes, funcionários terceirizados e afiliados, sem que seja necessário solicitar permissão adicional ou qualquer tipo de pagamento. Você especificamente e irrevocavelmente garante à Ellation o direito de usar e explorar a gravação, e cada elemento componente dela, em todo e qualquer tipo de mídia, conhecido ou ainda a ser inventado, em perpetuidade, em todo o universo, e para qualquer propósito, incluindo mas não limitado ao uso em websites, plataformas para celular e qualquer aplicativo que seja de propriedade, controle ou administração da Ellation ou qualquer um de seus licenciados e/ou afiliados, em qualquer publicidade relacionada a promoção ou marketing.
								</li>

								<li className="mb-15">
									Que você está ciente de que sua participação neste estudo de usabilidade é voluntário, e que você avisará imediatamente qualquer tipo de preocupação ou desconforto durante a sessão ao administrador do estudo.
								</li>

								<li className="mb-15">
									{`Que você usará as Informações Confidenciais da Ellation com o único propósito de participar desta pesquisa de usabilidade, e que você não divulgará as Informações Confidenciais da Ellation a terceiros de qualquer natureza. "Informações Confidenciais", neste contexto, se referem a qualquer tipo de informação não-pública relacionada aos negócios, produtos, pesquisas e desenvolvimento da Ellation, suas afiliadas ou subsisdiárias, atuais ou vindouros, ou a qualquer tipo de dado técnico, propriedade intelectual, segredos industriais ou know-how da Ellation, suas afiliadas, suas empresas-matrizes ou subsidiárias, incluindo mas não limitado a pesquisas, projetos de produto ou qualquer outra informação relacionada aos produtos, serviços e ofertas atuais ou futuras da Ellation, suas afiliadas, empresas-matrizes ou subsidiárias, tais como listas de consumidores ou informações ligadas a softwares, desenvolvimentos, invenções, processos, fórmulas, tecnologias, projetos, designs, esboços, engenharia, informação de configuração de hardware, marketing, finanças ou qualquer outra informação de negócios revelada pela Ellation, seja direta ou indiretamente, por escrito, via oral, ilustrações ou por inspeção de premissas, componentes, equipamentos ou qualquer outra propriedade da Ellation. Não obstante, Informações Confidenciais não incluem qualquer tipo de informação onde seja possível estabelecer que (i) a informação foi divulgada publicamente ou era de conhecimento público antes da divulgação da informação para o contratista, ou (ii) tornou-se publicamente conhecida ou foi divulgada publicamente após a divulgação do Contratista através de uma ação não relacionada com o Contratista.`}
								</li>
							</ol>

							<p id="SigningInstructions"
								className="font-bold">
								Ao assinar os termos abaixo, você declara ter lido este documento antes de assiná-lo, declara estar de acordo com os termos aqui estabelecidos e declara estar assinando de livre e espontânea vontade.
							</p>
						</div>
					</div>
				);
				declineText = "Recusar";
				acceptText = "Assinar Digitalmente";
				break;
			}
			case "amazon": case "pilotly-nda": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Security Consent Non-Disclosure Agreement</h4>
							<p>Please read the the following and be sure to scroll to the end to complete reading</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<p className="mb-20">
								Protecting your personal and confidential information is very serious to us and we follow strict privacy rules to ensure this. We also protect our client's confidential information with the same importance. For our client's benefit, it is mandatory, by participating in this study, you agree that you will not:
							</p>

							<ol>
								<li className="mb-15">
									Share any of the confidential and proprietary information included in this study, or use it for your own benefit or the benefit of a third party.
								</li>

								<li className="mb-15">
									Photograph, record, publish on the Internet, copy, or in any other way reproduce, any of the confidential information included in this study.
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								Do you acknowledge and agree to the statements above?
							</p>
						</div>
					</div>
				);
				declineText = "No, I do not agree";
				acceptText = "Yes, I agree and I wish to participate in this study";
				enableSigning = true;
				break;
			}
			case "amazon-it": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<p className="mb-10 consent-title text-align-left">Poiché ciò che vedrai oggi è confidenziale, per poter procedere, ti viene chiesto di apporre una firma digitale su un accordo di riservatezza (NDA).</p>

							<p className="text-align-left">Leggi tutti i termini e le condizioni seguenti, poi indica se le accetti o se desideri evitare di sottoporti a questo test</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<h5 className="mb-10"><b>ACCORDO DI RISERVATEZZA</b></h5>

							<p className="mb-20">
								{`Il presente Accordo di riservatezza (questo "Accordo") viene stipulato dal Partecipante a beneficio di Amazon.com, Inc. e le organizzazioni affiliate ad essa ("Amazon"). In connessione con la partecipazione del Partecipante a qualsiasi sondaggio, questionario o altra attività di condivisione delle informazioni con Amazon, il Partecipante può ricevere informazioni sull'operatività e le attività di Amazon. In considerazione della ricezione di tali informazioni, il Partecipante accetta quanto segue:`}
							</p>

							<ol>
								<li className="mb-15">
									{`Informazioni riservate. "Affiliato" indica, riguardo a qualsiasi persona giuridica distinta, qualsiasi altra persona giuridica distinta che controlla direttamente o indirettamente, è controllata da o è sotto il controllo comune con tale persona giuridica distinta, e "Informazioni riservate" indica tutte le informazioni non pubbliche relative ad Amazon o divulgate da Amazon o dalle sue organizzazioni affiliate al partecipante di cui sopra ("Partecipante") che sono designate come riservate o che, data la natura delle informazioni o le circostanze relative alla loro divulgazione, devono essere ragionevolmente considerate confidenziali (incluse immagini, video o qualsiasi altro materiale ).`}
								</li>

								<li className="mb-15">
									{`Uso di informazioni riservate. Salvo quanto previsto nel presente Accordo, il Partecipante non divulgherà, scaricherà, registrerà o condividerà informazioni riservate con nessuno senza il previo consenso scritto di Amazon. Il Partecipante adotterà tutte le misure ragionevoli per evitare la divulgazione, la diffusione o l'uso non autorizzato di informazioni riservate, comprese, come minimo, le misure che prende per proteggere le proprie informazioni riservate di natura simile.`}
								</li>

								<li className="mb-15">
									Proprietà delle informazioni riservate. Tutte le informazioni riservate rimarranno di proprietà esclusiva di Amazon. La divulgazione da parte di Amazon di informazioni riservate non costituirà una concessione esplicita o implicita al Partecipante di alcun diritto o brevetto, copyright, segreto commerciale, marchio commerciale o altri diritti di proprietà intellettuale di Amazon. Il Partecipante non utilizzerà alcun nome commerciale, marchio, logo o altri diritti di proprietà di Amazon (o dei suoi Affiliati) in alcun modo senza previa autorizzazione scritta di tale uso da parte di un Vice Presidente di Amazon (o della sua Affiliata applicabile).
								</li>

								<li className="mb-15">
									{`Avviso di utilizzo non autorizzato. Il Partecipante informerà immediatamente Amazon nel caso scoprisse qualsiasi utilizzo non autorizzato o divulgazione di Informazioni riservate o qualsiasi altra violazione del presente Accordo. Il Partecipante collaborerà con Amazon in ogni modo ragionevole per aiutare Amazon a riprendere possesso di tali Informazioni riservate e impedirne l'uso e la divulgazione non autorizzati.`}
								</li>

								<li className="mb-15">
									Restituzione di informazioni riservate. Il Partecipante restituirà o distruggerà tutti i materiali tangibili che incorporano le Informazioni riservate (in qualsiasi forma e inclusi, senza limitazione, tutti i riassunti, le copie e gli estratti delle Informazioni riservate) prontamente a seguito della richiesta scritta di Amazon.
								</li>

								<li className="mb-15">
									Provvedimento ingiuntivo. Il partecipante riconosce che una violazione dei propri obblighi ai sensi del presente Accordo potrebbe causare danni irreparabili ad Amazon in merito ai quali i danni monetari potrebbero essere difficili da accertare o un rimedio potrebbe essere inadeguato. Il Partecipante conviene che Amazon avrà il diritto, oltre agli altri suoi diritti e rimedi, di chiedere un provvedimento ingiuntivo per qualsiasi violazione del presente Accordo.
								</li>

								<li className="mb-15">
									{`Ambito di applicazione; Cessazione. Il presente Accordo copre le Informazioni riservate ricevute dal Partecipante prima e successivamente alla data del presente Accordo. Il presente Accordo è in vigore dalla data in cui le Informazioni riservate sono state ricevute per la prima volta e continuerà per 3 anni, dopodiché si rinnoverà automaticamente a meno che una delle parti non risolva il presente Accordo fornendo almeno 90 giorni di preavviso scritto all'altra parte, a condizione che gli obblighi del Partecipante in relazione alle Informazioni riservate sopravviveranno per 5 anni dopo la risoluzione del presente Accordo e le Sezioni 6, 9, 10 e 11 sopravviveranno indefinitamente e gli obblighi di riservatezza del presente Accordo continueranno ad applicarsi alle Informazioni Riservate fintanto che le informazioni continueranno a costituire un segreto commerciale o non rientreranno altrimenti in un'esclusione descritta nella sezione 2.`}
								</li>

								<li className="mb-15">
									{`Varie. Il presente Accordo costituisce l'intero accordo tra le parti in merito alle questioni discusse nel presente documento e può essere emendato, modificato o revocato solo con il reciproco consenso scritto delle parti. Il partecipante non può cedere il presente Accordo senza il consenso scritto di Amazon. Se una disposizione del presente Accordo viene ritenuta non valida ai sensi della legge applicabile, tale invalidità non influirà su alcuna altra disposizione del presente Accordo che possa essere resa effettiva. <b>Il presente Accordo sarà regolato e protetto dalle leggi internazionali sul copyright applicabili.</b>`}
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								Accetti i termini e le condizioni di cui sopra?
							</p>
						</div>
					</div>
				);
				declineText = "No";
				acceptText = "Sí";
				enableSigning = true;
				break;
			}
			case "amazon-eu-es": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<p className="mb-10 consent-title text-align-left">
								Debido a que lo que estás viendo hoy es confidencial, para continuar, debes firmar electrónicamente un Acuerdo de Confidencialidad.
							</p>

							<p className="text-align-left">
								Asegúrate de leer todos los términos y condiciones a continuación e indica si estás de acuerdo o si prefieres no participar en esta prueba.
							</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<h5 className="mb-10"><b>ACUERDO DE CONFIDENCIALIDAD</b></h5>

							<p className="mb-20">
								{`El Participante celebra este Acuerdo de Confidencialidad (el "Acuerdo") en beneficio de Amazon.com, Inc. y sus afiliados ("Amazon"). En relación con la participación del Participante en cualquier encuesta, cuestionario u otra actividad para compartir información con Amazon, el Participante puede recibir información sobre las operaciones y negocios de Amazon. Respecto a la recepción de dicha información, el Participante acepta lo siguiente:`}
							</p>

							<ol>
								<li className="mb-15">
									{`Información Confidencial. "Afiliado" significa, con respecto a cualquier entidad, cualquier otra entidad que directa o indirectamente controle, esté controlada por o esté bajo control común junto a esa entidad, e "Información Confidencial" significa toda información no pública relacionada con Amazon o divulgada por Amazon o sus Afiliados al participante mencionado anteriormente ("Participante") designada como confidencial o que, dada la naturaleza de la información o las circunstancias que rodean su divulgación, razonablemente deba considerarse como confidencial (esto incluye imágenes, vídeos o cualquier otro material).`}
								</li>

								<li className="mb-15">
									Uso de la Información Confidencial. Salvo lo dispuesto en este Acuerdo, el Participante no divulgará, descargará, registrará ni compartirá Información Confidencial con nadie sin el consentimiento previo por escrito de Amazon. El Participante tomará todas las medidas razonables para evitar la divulgación, difusión o uso no autorizado de la Información Confidencial, incluidas, como mínimo, las medidas que tome para proteger su propia información confidencial de naturaleza similar.
								</li>

								<li className="mb-15">
									Propiedad de la Información Confidencial. Toda la Información Confidencial seguirá siendo propiedad exclusiva de Amazon. La divulgación de Información Confidencial por parte de Amazon no constituirá una concesión expresa o implícita al Participante de ningún derecho sobre patentes, derechos de autor, secretos comerciales, marcas u otros derechos de propiedad intelectual de Amazon. El Participante no utilizará ningún nombre comercial, marca, logotipo o cualquier otro derecho propiedad de Amazon (o cualquiera de sus Afiliados) de ninguna manera sin la autorización previa por escrito de dicho uso por parte de un vicepresidente de Amazon (o de su Afiliado correspondiente).
								</li>

								<li className="mb-15">
									Aviso sobre usos no autorizados. El Participante avisará a Amazon inmediatamente después de descubrir cualquier uso o divulgación no autorizada de Información Confidencial o cualquier otro incumplimiento de este Acuerdo. El Participante colaborará con Amazon de todas las formas razonables para ayudar a Amazon a recuperar la posesión de dicha Información Confidencial y evitar su uso y divulgación no autorizados.
								</li>

								<li className="mb-15">
									Devolución de Información Confidencial. El Participante devolverá o destruirá todo el material tangible que contenga Información Confidencial (en cualquier forma e incluyendo, entre otros, todos los resúmenes, copias y extractos de Información Confidencial) inmediatamente después de la solicitud por escrito de Amazon.
								</li>

								<li className="mb-15">
									Medidas cautelares. El Participante reconoce que un incumplimiento de sus obligaciones en virtud de este Acuerdo podría causar un daño irreparable a Amazon en cuanto a que los daños monetarios podrían ser difíciles de determinar o no ser un remedio adecuado. El Participante acepta que Amazon tendrá el derecho, además de otros derechos y recursos, de buscar medidas cautelares ante cualquier violación de este Acuerdo.
								</li>

								<li className="mb-15">
									Alcance; Terminación. Este Acuerdo cubre la Información Confidencial recibida por el Participante antes y después de la fecha del presente documento. Este Acuerdo entra en vigor a partir de la fecha en que se recibe la Información Confidencial por primera vez y continuará durante 3 años, después de los cuales se renovará automáticamente a menos que cualquiera de las partes rescinda este Acuerdo con al menos 90 días de antelación con una notificación por escrito a la otra parte, habida cuenta que las obligaciones del Participante con respecto a la Información Confidencial perdurarán durante 5 años tras la terminación de este Acuerdo, y las Secciones 6, 9, 10 y 11 perdurarán indefinidamente y las obligaciones de confidencialidad de este Acuerdo continuarán aplicándose a la Información Confidencial mientras la información continúe constituyendo un secreto comercial o no tenga cabida en las exclusiones descritas en la Sección 2.
								</li>

								<li className="mb-15">
									Disposiciones varias. Este Acuerdo constituye el acuerdo completo entre las partes en relación a los asuntos aquí mencionados y solo puede ser enmendado, modificado o anulado con el consentimiento mutuo por escrito de las partes. El Participante no puede ceder este Acuerdo sin el consentimiento por escrito de Amazon. Si una disposición de este Acuerdo es considerada no válida según la legislación aplicable, dicha invalidez no afectará a la validez de ninguna otra disposición de este Acuerdo. <b>Este Acuerdo se regirá y estará protegido por las leyes internacionales aplicables de derechos de autor.</b>
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								¿Estás de acuerdo con los términos y condiciones anteriores?
							</p>
						</div>
					</div>
				);

				declineText = "No";
				acceptText = "Sí";
				enableSigning = true;
				break;
			}
			case "amazon-es": case "amazon-mx": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<p className="mb-10 consent-title text-align-left">
								Dado que lo que está viendo hoy es confidencial, para proceder debe firmar electrónicamente un  un Acuerdo de confidencialidad (ADC).
							</p>

							<p className="text-align-left">Lea en su totalidad los términos y condiciones que se establecen a continuación e indique si acepta o si le gustaría que se le excluya de esta prueba.</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<h5 className="mb-10"><b>ACUERDO DE CONFIDENCIALIDAD</b></h5>

							<p className="mb-20">
								El Participante suscribe el presente acuerdo de confidencialidad (este "Acuerdo") a favor de Amazon.com, Inc. y sus filiales ("Amazon"). En relación con la actuación del Participante en cualquier encuesta, cuestionario u otra iniciativa para compartir información con Amazon, el Participante podrá recibir información sobre las actividades y los negocios de Amazon. En lo relativo a la recepción de dicha información el Participante acepta lo siguiente:
							</p>

							<ol>
								<li className="mb-15">
									Información Confidencial. "Filial" significa, con respecto a cualquier entidad, cualquier otra entidad que ejerza control directa o indirectamente sobre esa entidad, esté controlada por esta o esté bajo control común con esa entidad, e "Información Confidencial" significa toda la información no pública relativa a Amazon o divulgada por Amazon o sus Filiales al participante indicado anteriormente ("Participante") que se designe como confidencial o que, dada la naturaleza de la información o de las circunstancias que rodean su divulgación, podría considerarse en forma razonable que es confidencial (eso incluye cualquier imagen, video o cualquier otro material).
								</li>

								<li className="mb-15">
									Uso de Información Confidencial. Excepto por lo dispuesto en este Acuerdo, el Participante no podrá divulgar, descargar, grabar ni compartir Información Confidencial con nadie sin el consentimiento previo por escrito de Amazon. El Participante tomará todas las medidas que resulten razonables para evitar la divulgación, la difusión o el uso no autorizado de Información Confidencial, lo que incluye, como mínimo, aquellas medidas que toma para proteger su propia información confidencial de naturaleza similar.
								</li>

								<li className="mb-15">
									Titularidad de la Información Confidencial. Toda la Información Confidencial continuará siendo propiedad exclusiva de Amazon. La divulgación de Información Confidencial por parte de Amazon no constituirá un otorgamiento expreso o implícito al Participante de derechos sobre ni en virtud de las patentes, los derechos de autor, los secretos comerciales, las marcas registradas ni otros derechos de propiedad intelectual de Amazon. El Participante no usará los nombres comerciales, las marcas registradas, los logotipos ni otros derechos propietarios de Amazon (ni de cualquiera de sus Vinculadas) de ninguna manera sin la autorización previa por escrito para tal uso de parte del Vicepresidente de Amazon (o su Vinculada correspondiente).
								</li>

								<li className="mb-15">
									Aviso de Uso No Autorizado. El Participante notificará a Amazon de inmediato si llegara a descubrir un uso no autorizado o divulgación de Información Confidencial o cualquier otra infracción de este Acuerdo. El Participante cooperará con Amazon de cualquier otro modo que resulte razonable para ayudar a Amazon a retomar el poder de dicha Información Confidencial y evitar que persista su divulgación o uso no autorizado.
								</li>

								<li className="mb-15">
									Devolución de Información Confidencial. El Participante devolverá o destruirá todos los materiales tangibles que representen Información Confidencial (en cualquier forma, e incluyendo, sin limitación, todo resumen, copia o extracto de Información Confidencial) de inmediato tras un pedido por escrito de Amazon.
								</li>

								<li className="mb-15">
									Medidas Cautelares. El Participante reconoce que una infracción de sus obligaciones en virtud de este Acuerdo podría ocasionar un daño irreparable a Amazon por el cual los daños monetarios podrían ser difíciles de determinar o podrían ser una reparación insuficiente. El Participante acepta que Amazon tendrá derecho a solicitar medidas cautelares por cualquier infracción de este Acuerdo, además de sus otros derechos y recursos.
								</li>

								<li className="mb-15">
									Alcance; Rescisión. El Acuerdo alcanza toda la Información Confidencial que reciba el Participante con anterioridad y posterioridad a la fecha del presente. Este Acuerdo entra en vigor en la fecha en que se reciba por primera vez Información Confidencial y permanecerá vigente por un plazo de 3 años, después del cual se renovará automáticamente a menos que alguna de las partes rescinda el Acuerdo mediante una notificación por escrito a la otra parte con 90 días de antelación, como mínimo, sin perjuicio de lo cual las obligaciones del Participante con respecto a la Información Confidencial persistirán por 5 años después de la rescisión de este Acuerdo, y las cláusulas 6, 9, 10 y 11 continuarán en vigor indefinidamente y las obligaciones de confidencialidad de este Acuerdo continuarán siendo de aplicación a la Información Confidencial por todo el tiempo en que la información siga constituyendo un secreto comercial o no esté alcanzada por la exclusión descripta en la cláusula 2.
								</li>

								<li className="mb-15">
									Otras Disposiciones. Este Acuerdo constituye la totalidad del acuerdo entre las partes en lo relativo a las cuestiones tratadas aquí y solamente puede enmendarse, modificarse o suspenderse con el consentimiento mutuo por escrito de las partes. El Participante no podrá ceder este Acuerdo sin el consentimiento por escrito de Amazon. Si alguna disposición de este Acuerdo se considerara inválida en virtud de la legislación aplicable, dicha invalidez no afectará ninguna otra disposición de este Acuerdo a la que podría otorgarse efecto. Este Acuerdo se regirá por las leyes internas del Estado de Washington, sin referencia a sus principios de elección de derecho. Los tribunales estatales y federales del Condado King, Washington, tendrán competencia exclusiva y fueros sobre toda demanda que surja del presente Acuerdo o se relacione con él, y cada una de las partes acepta la competencia personal y los fueros de dichos tribunales. Todas las notificaciones en virtud del presente serán por escrito y se enviarán mediante un servicio de mensajería rápida, transmisión confirmada de fax, correo certificado. Las notificaciones a Amazon se enviarán en atención a General Counsel, a: 410 Terry Avenue North, Seattle, WA 98109-5210; número de fax 206/266.7010.
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								¿Acepta los términos y condiciones precedentes?
							</p>
						</div>
					</div>
				);
				declineText = "No";
				acceptText = "Sí";
				enableSigning = true;
				break;
			}
			case "amazon-de": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">GEHEIMHALTUNGSVEREINBARUNG</h4>

							<p className="mb-10">Heute siehst du vertrauliches Material. Daher musst du elektronisch eine Geheimhaltungsvereinbarung unterzeichnen, um fortzufahren.</p>

							<p>
								Bitte lies dir alle unten angeführten Bedingungen durch und gib an, ob du mit ihnen einverstanden bist oder nicht an diesem Test teilnehmen möchtest.
							</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<p className="mb-20">
								Diese Geheimhaltungsvereinbarung (diese "Vereinbarung") wird vom Teilnehmer zugunsten von Amazon.com, Inc. und seinen verbundenen Unternehmen ("Amazon") geschlossen. In Verbindung mit der Teilnahme des Teilnehmers an Umfragen, Fragebögen oder anderen Bemühungen zum Zwecke des Informationsaustauschs mit Amazon erhält der Teilnehmer unter Umständen Informationen über den Betrieb und die Geschäfte von Amazon. In Anbetracht dessen, dass dem Teilnehmer derartige Informationen zuteilwerden, erklärt dieser sich mit folgenden Punkten einverstanden:

							</p>

							<ol>
								<li className="mb-15">
									Vertrauliche Informationen. "Verbundenes Unternehmen" bezeichnet in Bezug auf eine juristische Person jede andere juristische Person, die diese direkt oder indirekt kontrolliert, von ihr kontrolliert wird oder mit ihr unter gemeinsamer Kontrolle steht. "Vertrauliche Informationen" bezeichnet alle nicht öffentlichen Informationen, die sich auf Amazon beziehen oder von Amazon oder seinen verbundenen Unternehmen gegenüber dem oben genannten Teilnehmer ("Teilnehmer") offengelegt werden, die als vertraulich bezeichnet werden oder die aufgrund der Art der Informationen oder der Umstände ihrer Offenlegung vernünftigerweise als vertraulich betrachtet werden müssen (dies umfasst Bilder, Videos oder andere Materialien).
								</li>

								<li className="mb-15">
									Verwendung vertraulicher Informationen. Der Teilnehmer wird abseits der Bestimmungen dieser Vereinbarung ohne die vorherige schriftliche Genehmigung von Amazon keine vertraulichen Informationen offenlegen, herunterladen, aufzeichnen oder mit jemandem teilen. Der Teilnehmer ergreift alle ihm zumutbaren Maßnahmen, um die Offenlegung, Verbreitung oder unbefugte Verwendung von vertraulichen Informationen zu verhindern. Mindestens umfassen diese Maßnahmen jene Bemühungen, die er selbst zum Schutz seiner eigenen vertraulichen Informationen ähnlicher Art ergreift.
								</li>

								<li className="mb-15">
									Eigentum an vertraulichen Informationen. Sämtliche vertraulichen Informationen bleiben das alleinige Eigentum von Amazon. Die Offenlegung von vertraulichen Informationen durch Amazon stellt keine ausdrückliche oder stillschweigende Gewährung von Rechten an oder im Rahmen der Patente, Urheberrechte, Geschäftsgeheimnisse, Marken oder anderen geistigen Eigentumsrechten von Amazon an den Teilnehmer dar. Der Teilnehmer verwendet keine Handelsnamen, Markenzeichen, Logos oder andere Schutzrechte von Amazon (oder einem seiner verbundenen Unternehmen) auf irgendeine Art und Weise ohne die vorherige schriftliche Genehmigung einer solchen Verwendung durch einen Vice President (Vizepräsident) von Amazon (oder des entsprechenden verbundenen Unternehmens).
								</li>

								<li className="mb-15">
									Hinweis bei unbefugter Verwendung. Der Teilnehmer benachrichtigt Amazon unverzüglich, sobald er Kenntnis über eine unbefugte Verwendung oder Offenlegung von vertraulichen Informationen oder einen anderen Verstoß gegen diese Vereinbarung erlangt. Der Teilnehmer arbeitet mit Amazon auf jegliche angemessene Art und Weise zusammen, um Amazon dabei zu unterstützen, wieder in den Besitz solcher vertraulichen Informationen zu gelangen und deren weitere unbefugte Verwendung und Offenlegung zu verhindern.
								</li>

								<li className="mb-15">
									Rückgabe von vertraulichen Informationen. Der Teilnehmer gibt sämtliche dingliche Materialien, die vertrauliche Informationen darstellen (unabhängig von ihrer Form und insbesondere alle Zusammenfassungen, Kopien und Auszüge von vertraulichen Informationen) unverzüglich nach der schriftlichen Aufforderung durch Amazon zurück oder vernichtet diese.
								</li>

								<li className="mb-15">
									Unterlassungsanspruch. Der Teilnehmer erkennt an, dass ein Verstoß gegen seine Verpflichtungen aus dieser Vereinbarung Amazon irreparablen Schaden zufügen kann. Der finanzielle Schaden lässt sich dabei unter Umständen nur schwer ermitteln oder nur unzureichend beheben. Der Teilnehmer erklärt sich damit einverstanden, dass Amazon zusätzlich zu seinen anderen Rechten und Rechtsmitteln das Recht eingeräumt wird, bei Verstößen gegen diese Vereinbarung Unterlassungsansprüche geltend zu machen.
								</li>

								<li className="mb-15">
									Geltungsbereich; Kündigung. Diese Vereinbarung bezieht sich auf vertrauliche Informationen, die der Teilnehmer vor und nach dem Datum des Abschlusses dieser Vereinbarung erhält bzw. erhalten hat. Diese Vereinbarung gilt ab dem Datum des erstmaligen Erhalts von vertraulichen Informationen für drei Jahre. Danach verlängert sich die Geltungsdauer dieser Vereinbarung automatisch, sofern sie nicht durch eine der Parteien mindestens 90 Tage im Voraus durch schriftliche Mitteilung an die andere Partei gekündigt wird. Hierbei wird vorausgesetzt, dass die Verpflichtungen des Teilnehmers in Bezug auf vertrauliche Informationen 5 Jahre nach Kündigung dieser Vereinbarung fortbestehen und die Abschnitte 6, 9, 10 und 11 auf unbestimmte Zeit bestehen bleiben. Die Vertraulichkeitspflichten dieser Vereinbarung gelten weiterhin für die vertraulichen Informationen, solange diese ein Geschäftsgeheimnis darstellen oder anderweitig nicht unter eine der in Abschnitt 2 beschriebenen Ausnahmen fallen.
								</li>

								<li className="mb-15">
									Verschiedenes. Diese Vereinbarung stellt die gesamte Vereinbarung zwischen den Parteien in Bezug auf die hier behandelten Angelegenheiten dar und kann nur mit beiderseitiger schriftlicher Zustimmung der Parteien ergänzt, geändert oder aufgehoben werden. Der Teilnehmer darf diese Vereinbarung nicht ohne die schriftliche Genehmigung von Amazon an jemand anderen übertragen. Sollte eine Bestimmung dieser Vereinbarung nach geltendem Recht für ungültig erklärt werden, so hat diese Ungültigkeit keinen Einfluss auf die anderen Bestimmungen dieser Vereinbarung, die weiterhin durchgesetzt werden können. Diese Vereinbarung unterliegt den geltenden internationalen Urheberrechtsgesetzen und wird durch diese geschützt.
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								Bist du mit den oben angeführten Bedingungen einverstanden?
							</p>
						</div>
					</div>
				);

				declineText = "Nein";
				acceptText = "Ja";
				enableSigning = true;
				break;
			}
			case "amazon-br": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Acordo de confidencialidade e consentimento de segurança</h4>
							<p>Por favor, leia a seguir, e role até o final para concluir a leitura</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<p className="mb-20">
								A proteção de suas informações pessoais e confidenciais é muito séria para nós, e seguimos rigorosas regras de privacidade para garantir isso. Também protegemos as informações confidenciais de nossos clientes com a mesma importância. Para o benefício de nossos clientes, é obrigatório, ao participar deste estudo, que você concorda que não irá:
							</p>

							<ol>
								<li className="mb-15">
									Compartilhar qualquer informação confidencial e proprietária incluída neste estudo, ou usa-lá para seu próprio benefício, ou para o benefício de terceiros.
								</li>

								<li className="mb-15">
									Fotografar, gravar, publicar na Internet, copiar, ou de qualquer outra forma, reproduzir qualquer informação confidencial incluída neste estudo.
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								Você reconhece e concorda com as declarações acima?
							</p>
						</div>
					</div>
				);
				declineText = "Não, eu não concordo";
				acceptText = "Sim, concordo e desejo participar deste estudo";
				enableSigning = true;
				break;
			}
			case "amazon-ja": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">
								お客様がこれから受領する情報はアマゾンの重要な秘密情報に当たるため、調査へ参加頂く前に、下記守秘義務契約にご同意いただく必要がございます。
							</h4>
							<p>
								下記守秘義務に関する条項を全てお読みいただき、ご同意ください（ご同意いただけない場合は調査に参加いただくことができません）。
							</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<p className="mb-20">
								本守秘義務契約（「本契約」）は、Amazon.com, Inc.及びその関連会社（「アマゾン」）のため、参加者（「本件参加者」）が締結するものです。本件参加者は、調査、アンケート又はその他のアマゾンとの情報共有の試みへの参加に関連し、アマゾンの業務及びビジネスに関する情報を受け取ることがあります。こうした情報の受け取りのため、本件参加者は以下の通り同意します。
							</p>

							<ol>
								<li className="mb-15">
									<u>秘密情報</u> 「関連会社」は、ある法人を直接的又は間接的に支配する会社、ある法人に支配される会社、又はある法人と共通の支配下にある会社を意味します。「秘密情報」は、アマゾンに関連する、又はアマゾン若しくはアマゾンの関連会社が秘密情報として指定したうえで、若しくはその情報の特性若しくは開示に関わる状況から秘密であると合理的に判断されるもので、本件参加者に開示する全ての非公開情報（画像、動画又は他の資料を含みます）を意味します。
								</li>

								<li className="mb-15">
									<u><b>秘密情報の使用</b></u>　本契約で定めるものを除き、本件参加者は、アマゾンから事前に書面で同意を得ることなく、秘密情報を開示、ダウンロード、記録又は共有してはなりません。本件参加者は、秘密情報の開示、拡散、無断使用を防ぐための全ての合理的な措置を講じます。こうした措置には、本件参加者が、自らの秘密情報を保護するために講じる措置も含まれます。
								</li>

								<li className="mb-15">
									<u><b>秘密情報の所有権</b></u>　開示された秘密情報は全て、今後も引き続きアマゾンの独占的財産となります。アマゾンが秘密情報を開示した場合でも、アマゾンが本件参加者に対してアマゾンの特許、著作権、企業秘密、商標若しくは他の知的財産権に対する又はそれらに基づく権利を明示的又は黙示的に許諾するものではありません。本件参加者は、その方法を問わず、アマゾン（又は該当する関連会社）のバイス・プレジデントから事前に書面で許可を得ることなく、アマゾン（又はその関連会社）の商号、商標、ロゴ又はその他の財産権を使用してはなりません。
								</li>

								<li className="mb-15">
									<u><b>無断使用の通知</b></u>　本件参加者は、秘密情報の無断使用若しくは開示又はその他の本契約違反を発見した時点で、速やかにアマゾンに通知します。本件参加者は、アマゾンの秘密情報の権利回復、更なる無断使用及び開示を防ぐため、全ての合理的な方法を用いてアマゾンに協力します。
								</li>

								<li className="mb-15">
									<u><b>秘密情報の返却</b></u>　本件参加者は、アマゾンから書面で要請を受けた場合、秘密情報を具体化する全ての有形資料（その形態を問わず、秘密情報の全ての要約、コピー及び抜粋を含むが、これらに限定されません）を速やかに返却又は破棄します。
								</li>

								<li className="mb-15">
									<u><b>差止による救済</b></u>　本件参加者は、本件参加者が本契約の義務を違反することで、損害額を把握しがたい又は金銭による損害賠償では回復不可能な損害をアマゾンに引き起こす可能性があることを認識します。本件参加者は、アマゾンが他の権利及び救済に加えて、本契約違反に対して差止による救済を請求する権利を有することに同意します。
								</li>

								<li className="mb-15">
									<u><b>範囲及び終了</b></u>　本契約は、本契約に同意した日の前後に、本件参加者が受け取る秘密情報を対象とします。本契約は、秘密情報を最初に受け取った日から発効し、3年間継続し、その後はいずれかの当事者が他方当事者に対して90日以上前に書面で通知して本契約を終了しない限り、自動的に更新します。ただし、秘密情報に関する本件参加者の義務は、本契約終了後5年間存続し、第3条、第6条、第7条及び第8条は、期限を定めることなく存続します。本契約の秘密保持義務は、その情報が企業秘密であり続ける限り、秘密情報に適用し続けます。
								</li>

								<li className="mb-15">
									<u><b>雑則</b></u>　本契約は、本契約に記載された事項に関する両当事者間の完全なる合意を構成し、両当事者が互いに書面で合意する場合に限り、修正、変更又は放棄することができます。本件参加者は、アマゾンから書面で同意を得ずに、本契約を譲渡することはできません。本契約の一部の条項が適用法令に基づき無効とされる場合、当該無効は、本契約の他の有効な条項に影響を及ぼしません。本契約は、日本法に準拠し、これに従って解釈されるものとします。両当事者は、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
								</li>
							</ol>

							<p id="SigningInstructions" className="font-bold">
								上記の契約条件に同意頂けますでしょうか？
							</p>
						</div>
					</div>
				);
				declineText = "いいえ";
				acceptText = "はい";
				enableSigning = true;
				break;
			}
			case "netflix-us": {
				consentForm = (
					<div className="pilotly-register-form video-consent p-0">
						<div className="register-form-message mb-10">
							<h4 className="mb-10 consent-title">Terms of Participation</h4>
							<p>Thank you for agreeing to participate in this project, which Pilotly is conducting on behalf of our client. We ask that you carefully read and accept the terms on this screen, which contains the legal wording regarding the project and the requirement for you to keep it confidential.</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className={"mb-20 overflow-auto text-align-left " + consentClassName}>

							<p className="mb-20">
								By accepting below, you agree to the following:
							</p>

							<ul className='pl-40'>
								<li className="disc mb-15">
									As part of the project, you will have access to certain information that we need you to keep confidential. In exchange for the ability to participate in the project and any additional consideration we may provide, you will not share or disclose any details of the project, including on social media.
								</li>

								<li className="disc mb-15">
									Your obligation not to share or disclose also extends to any materials, information or data related to the project ("Materials"). Those Materials are provided to you as-is and are owned by us. You have no right to photograph, copy or otherwise use the Materials.
								</li>

								<li className="disc mb-15">
									Any suggestions, comments or other feedback you provide as part of this project are given voluntarily. You give us and our client the unrestricted right to use these suggestions, comments or other feedback as we see fit.
								</li>

								<li className="disc mb-15">
									We may videotape or otherwise record the project. You give us permission to use those recordings, including those that may contain your image, likeness, and voice, for our business purposes.
								</li>

								<li className="disc mb-15">
									This document is governed by and interpreted in accordance with California law. California courts will have exclusive jurisdiction over any disputes that arise.
								</li>

								<li className="disc mb-15">
									If any part of this agreement is found to be unenforceable, the remainder of the agreement will continue to be in effect.
								</li>
							</ul>

							<p id="SigningInstructions" className="font-bold">
								Do you agree and accept the statements above?
							</p>
						</div>
					</div>
				);
				declineText = "No, I do not agree";
				acceptText = "Yes, I agree and I wish to participate in this study";
				enableSigning = true;
			}
		}

		if (consentForm) {
			return (
				<div>
					{consentForm}

					<div className={"pb-10 " + (DeviceHelper.isMobile ? 'viewer-consent-buttons-container' : 'position-relative')}>
						<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize mr-15 transparent pilotly-home-footer-sign-out-button-no offOnTrans" + (this.state.ready ? " on" : "")}
							onClick={() => this.declineConsentDisclaimer(CONSENT_FORM_TERMINATION)}
							disabled={!this.state.ready}>
							{declineText}
						</button>

						<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans" + (this.state.ready ? " on" : "")}
							onClick={() => this.acceptConsentDisclaimer()}
							disabled={!this.state.ready || !enableSigning}>
							{acceptText}
						</button>
						<PageLoader loading={!this.state.ready} small={true} addedClass="transparent-background" />
					</div>
				</div>
			);
		}
		else {
			return '';
		}
	}

	renderLaymensTerms(formType, laymensPromptDisplay) {
		let ndaPrompt = this.state.ndaPrompt;
		switch (formType) {
			case 'nda-prompt': {
				if (DeviceHelper.isMobile && laymensPromptDisplay) {
					return <MobileLaymensTerms continueStudy={this.continueStudy} intl={this.props.intl} ndaPrompt={ndaPrompt} />;
				}

				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								{ndaPrompt && ndaPrompt.agreement ?
									ndaPrompt.agreement
									:
									<FormattedMessage
										id="viewer_consent.laymens.thanks"
										defaultMessage={`Thank you for keeping this study confidential. Your digital signature means {agreement}`}
										values={{ agreement: <b>{this.props.intl.formatMessage(localeMessages.agreement)}</b> }}
									/>
								}
							</p>
						</div>

						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>

									<div className="laymens-terms inline-block width-70p ml-25">
										<p>
											{ndaPrompt && ndaPrompt.laymens_social_media_agreement ?
												ndaPrompt.laymens_social_media_agreement
												:
												<FormattedMessage
													id="viewer_consent.laymens.social_media"
													defaultMessage={`{social_media_instructions} Related To Your Experience On Social Media`}
													values={{ social_media_instructions: <u>{this.props.intl.formatMessage(localeMessages.social_media_instructions)}</u> }}
												/>
											}
										</p>
									</div>
								</li>

								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										{ndaPrompt && ndaPrompt.laymens_video_share_agreement ?
											ndaPrompt.laymens_video_share_agreement
											:
											<FormattedMessage
												id="viewer_consent.laymens.store_content"
												defaultMessage={`{store_content_instructions} (Video, Images, etc) From This Study`}
												values={{ store_content_instructions: <u>{this.props.intl.formatMessage(localeMessages.store_content_instructions)}</u> }}
											/>
										}
									</div>
								</li>
							</ul>
						</div>

						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration offOnTrans on text-transform-none"}
								onClick={() => this.continueStudy()}>
								{ndaPrompt && ndaPrompt.laymens_understand_consent ?
									ndaPrompt.laymens_understand_consent
									:
									<FormattedMessage
										id="viewer_consent.laymens.button.understand"
										defaultMessage={`I Understand the Above`}
									/>
								}
							</button>
						</div>
					</div>
				);
			}
			case "amazon-it": case "ellation-it": {
				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								Grazie per aver rispettato la riservatezza di questo studio. <b>La tua firma digitale indica che hai accettato quanto segue:</b>
							</p>
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<u>Non pubblicare niente</u> relativo alla tua esperienza sui social media
									</div>
								</li>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<u>Non conservare o condividere alcun contenuto</u>  (video, immagini, ecc.) di questo studio
									</div>
								</li>
							</ul>
						</div>
						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans on"}
								onClick={() => this.continueStudy()}>
								Comprendo quanto sopra
							</button>
						</div>
					</div>
				);
			}
			case "amazon-es": case "amazon-mx": case "amazon-eu-es": {
				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								Gracias por mantener este estudio confidencial. Su firma digital significa que aceptó lo siguiente
							</p>
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										No publicar nada relacionado con su experiencia en las redes sociales
									</div>
								</li>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										No almacenar o compartir ningún contenido (video, imágenes, etc.) de este estudio (edited)
									</div>
								</li>
							</ul>
						</div>
						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans on"}
								onClick={() => this.continueStudy()}>
								Entiendo lo anterior
							</button>
						</div>
					</div>
				);
			}
			case "amazon-de": {
				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								Bitte bewahren Sie über diese Studie Stillschweigen. Mit Ihrer digitalen Unterschrift stimmen Sie den folgenden Punkten zu:
							</p>
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										Posten Sie nichts über Ihre Erlebnisse in den sozialen Netzwerken.
										{/* <u>Do Not Post Anything</u> Related To Your Experience On Social Media */}
									</div>
								</li>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										Speichern und teilen Sie keine Inhalte (Videos, Bilder usw.) aus dieser Studie.
										{/* <u>Do Not Store or Share Any Content</u> (Video, Images, etc) From This Study */}
									</div>
								</li>
							</ul>
						</div>

						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans on"}
								onClick={() => this.continueStudy()}>
								Ich verstehe die oben genannten Punkte.
							</button>
						</div>
					</div>
				);
			}
			case "ellation-mx": {
				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								<b>Muchas gracias por mantener la confidencialidad del estudio. Su firma digital implica que accede a las siguientes condiciones:</b>
							</p>
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<u>No mencione nada</u> relacionado con su experiencia en redes sociales
									</div>
								</li>

								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<u>No comparta contenido de ningún tipo</u> (video, imágenes, etc) derivado de este estudio
									</div>
								</li>
							</ul>
						</div>

						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans on"}
								onClick={() => this.continueStudy()}>
								Comprendo lo anterior
							</button>
						</div>
					</div>
				);
			}
			case "ellation-br": case "amazon-br": {
				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								<b>Obrigado por manter a confidencialidade do estudo. Sua assinatura digital implica nas seguintes restrições:</b>
							</p>
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										Não poste nada relacionado à sua experiência nas redes sociais
									</div>
								</li>

								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										Não armazene ou compartilhe qualquer tipo de conteúdo (vídeo, imagens, etc) pertencentes a este estudo
									</div>
								</li>
							</ul>
						</div>

						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration text-capitalize offOnTrans on"}
								onClick={() => this.continueStudy()}>
								Eu entendo o acima
							</button>
						</div>
					</div>
				);
			}
			default: {
				if (DeviceHelper.isMobile && laymensPromptDisplay) {
					return <MobileLaymensTerms continueStudy={this.continueStudy} intl={this.props.intl} ndaPrompt={ndaPrompt} />;
				}

				return (
					<div className={"pilotly-register-form video-consent m-auto width-50p p-0 offOnTrans" + (laymensPromptDisplay ? " on" : " position-absolute position-offscreen")}>
						<div className="register-form-message mb-10">
							<p>
								<FormattedMessage
									id="viewer_consent.laymens.thanks"
									defaultMessage={`Thank you for keeping this study confidential. Your digital signature means {agreement}`}
									values={{ agreement: <b>{this.props.intl.formatMessage(localeMessages.agreement)}</b> }}
								/>
							</p>
							{/* <p>Thank you for keeping this study confidential. Your digital signature means <b>you agreed to the following</b></p> */}
						</div>
						<div id="ConsentForm"
							onScroll={this.trackScrolling}
							className="mb-20 overflow-auto text-align-left">
							<ul>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={SocialShare}
										alt="Social Media Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<FormattedMessage
											id="viewer_consent.laymens.social_media"
											defaultMessage={`{social_media_instructions} Related To Your Experience On Social Media`}
											values={{ social_media_instructions: <u>{this.props.intl.formatMessage(localeMessages.social_media_instructions)}</u> }}
										/>
										{/* <u>Do Not Post Anything</u> Related To Your Experience On Social Media */}
									</div>
								</li>
								<li className="position-relative mb-15">
									<img className="inline-block"
										src={VideoShare}
										alt="Video Sharing"
										style={{ width: "23%" }}
									/>
									<div className="laymens-terms inline-block width-70p ml-25">
										<FormattedMessage
											id="viewer_consent.laymens.store_content"
											defaultMessage={`{store_content_instructions} (Video, Images, etc) From This Study`}
											values={{ store_content_instructions: <u>{this.props.intl.formatMessage(localeMessages.store_content_instructions)}</u> }}
										/>
										{/* <u>Do Not Store or Share Any Content</u> (Video, Images, etc) From This Study */}
									</div>
								</li>
							</ul>
						</div>

						<div className="position-relative pb-10">
							<button className={"waves-effect waves-light btn register-field-submit begin-registration offOnTrans on text-transform-none"}
								onClick={() => this.continueStudy()}>
								<FormattedMessage
									id="viewer_consent.laymens.button.understand"
									defaultMessage={`I Understand the Above`}
								/>
							</button>
						</div>
					</div>
				);
			}
		}
	}

	render() {
		let consentPromptDisplay = this.state.consentPromptDisplay;
		let laymensPromptDisplay = this.state.laymensPromptDisplay;
		let screenerPrompt = this.returnScreenerPrompt(this.props.fetchedGroup, this.props.targetParams);
		let branding = this.returnScreenerBranding(screenerPrompt);
		let laymensTermsForm = this.renderLaymensTerms(screenerPrompt, laymensPromptDisplay);

		if (this.state.userStudyStatus) {
			return <Feedback {...this.props} feedbackType={this.state.userStudyStatus} />;
		}

		return (
			<FadeIn>
				<div className={'pilotly-register ' + (DeviceHelper.isMobile ? 'pilotly-register-mobile' : '')}>
					<div className={'top-100 register-form-wrapper ' + (DeviceHelper.isMobile && laymensPromptDisplay ? 'laymens-terms-mobile' : '')}>
						<div className="row ready-to-begin">
							<div className="pb-15 mb-30">
								<img src={branding} alt="branding" style={{ width: "30%" }} />
							</div>

							{consentPromptDisplay ?
								<FadeIn>
									{this.renderViewerConsentForm(screenerPrompt)}
								</FadeIn>
								:
								""
							}

							{laymensTermsForm}
						</div>
					</div>
				</div>
			</FadeIn>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		currentUserLocation: state.currentUser.currentUserLocation,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams,
		userDisclaimer: state.currentUser.userDisclaimer,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setTargetParams,
		setCurrentUser,
		setUserDisclaimer
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ViewerConsentDisclaimer));



// WEBPACK FOOTER //
// ./src/pages/ViewerConsent.js